export default {
  id: {
    dbKey: 'id',
    type: 'int',
    displayName: 'ID',
  },
  app: {
    dbKey: 'app',
    type: 'string',
    displayName: 'App',
    validationRules: [
      value => (!!value || (value && false)) || 'Required',
    ],
  },
  appVersion: {
    dbKey: 'appVersion',
    type: 'string',
    displayName: 'App Version',
    validationRules: [
      function (value) {
        return value === null || value === '' || value.length >= 5 || 'Min 5 characters';
      },
    ],
  },
  appVersionCurrent: {
    dbKey: 'appVersionCurrent',
    type: 'string',
    displayName: 'App Version Current',
  },
  customName: {
    dbKey: 'customName',
    type: 'string',
    displayName: 'Custom Name',
  },
  expiresAt: {
    dbKey: 'expiresAtFormatted',
    type: 'string',
    displayName: 'Expires At',
  },
  api: {
    dbKey: 'api',
    type: 'string',
    displayName: 'Endpoint',
  },
  active: {
    dbKey: 'active',
    type: 'boolean',
    displayName: 'Status',
  },
  customer: {
    dbKey: 'customer',
    type: 'string',
    displayName: 'Customer Id',
  },
  token: {
    dbKey: 'token',
    type: 'string',
    displayName: 'Token',
  },
  mock: {
    id: 0,
    app: '',
    appVersion: '',
    appVersionCurrent: '',
    customName: null,
    expiresAt: null,
    api: null,
    active: false,
    customer: '',
    token: '',
  },
};
